<template>
	<div class="h-100 w-100">
		<mapbox v-if="mapParams.loaded"></mapbox>
		<router-view></router-view>
		<div v-if="!mapLoaded" class="loading d-flex bg-dk">
			<div class="loading-dots justify-content-center align-self-center">
				<div class="dot"></div>
				<div class="dot"></div>
				<div class="dot"></div>
			</div>
		</div>
	</div>
</template>

<script>
import mapbox from '../map/mapbox.vue';

export default {
	name:'route',
	components:{
		mapbox
	},
	data:function(){
		return {
			prevMapPath: null
		};
	},
	created: function(){
		let newRoute = this.$router.currentRoute;

		let params = {
			loaded:true
		};

		if (newRoute && newRoute.params && newRoute.params.map){
			let mapStr = newRoute.params.map.substr(1);
			let queryAry = mapStr.split('&');
			let posAry = queryAry[0].split(',');
			if (posAry[0] && posAry[1]){
				params.lat = Number(posAry[0]);
				params.lng = Number(posAry[1]);
			}
			if (posAry[2]){
				params.zoom = Number(posAry[2]);
			}
			if (posAry[3]){
				params.pitch = Number(posAry[3]);
			}
			if (posAry[4]){
				params.bearing = Number(posAry[4]);
			}
			if (queryAry.length > 1){ // additional params
				for (let i=1,len=queryAry.length;i<len;i++){
					let qAry = queryAry[i].split('=');
					params[qAry[0]] = qAry[1];
				}
			}
		}
		this.$store.dispatch('MAP_PARAMS_SET', params);
	},
	computed: {
		mapParams: function(){
			return this.$store.state.map.params;
		},
		mapLoaded: function(){
			return this.$store.state.map.loaded;
		}
	},
	
	methods: {
		updatePath: function(){
			if (this.mapParams.lat === null) return; // escape if no map params are set
			let lat = parseFloat(this.mapParams.lat).toFixed(4);
			let lng = parseFloat(this.mapParams.lng).toFixed(4);
			let zoom = parseFloat(this.mapParams.zoom).toFixed(2);

			let path = '@'+lat+','+lng+','+zoom;
			if (this.mapParams.pitch){
				let pitch = parseFloat(this.mapParams.pitch).toFixed(2);
				path += ','+pitch;
			}
			if (this.mapParams.bearing){
				let bearing = parseFloat(this.mapParams.bearing).toFixed(2);
				path += ','+bearing;
			}
			if (this.mapParams.style !== 'vector'){
				path += '&style='+this.mapParams.style;
			}

			if (path === this.prevMapPath) return;

			this.prevMapPath = path;

			const params = {...this.$router.currentRoute.params, map:path};

			this.$router.replace({params:params,query:this.$router.currentRoute.query});
		}
	},
	watch: {
		mapParams:{
			deep:true, // will watch all properties of the params object
			handler:function(){
				this.updatePath();
			}
		},
		$route: function(newRoute, oldRoute){
			// put params on new route
			this.$store.dispatch('ERROR_MESSAGE_CLEAR');
			if (!newRoute.params.map && oldRoute.params.map){
				const params = {...newRoute.params, map:oldRoute.params.map};
				this.$router.replace({params:params,query:newRoute.query});
			}
		}
	}
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/route/route.vue